import { RadioField, TextField } from '@calendly/form';
import { object, string } from '@calendly/form/validation';
import { I18n } from '@calendly/i18n';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { isNoTouchDevice } from 'services/touch_device_detection';
import { canHideLocationSelector } from '../selectors';
import { useStateValue } from '../state_provider';
import { CustomLocationPopup } from './custom_location_popup';
const paddedTextFieldCss = "po4pj5g";
const PaddedTextField = forwardRef((props, ref) => <TextField ref={ref} {...props} className={classNames(paddedTextFieldCss, props.className)} />);
export const CustomPopup = () => {
  const state = useStateValue();
  const canHideLocation = canHideLocationSelector(state);
  const validationSchema = object({
    location: string().trim().required(I18n.t('publisher.event_types.location.custom_location_required')).matches(/^[^<>]*$/, I18n.t('publisher.event_types.location.custom_location_invalid_character')),
    additionalInfo: string().trim(),
    hideLocation: string().required().oneOf(['hidden', 'visible'])
  });
  return <CustomLocationPopup validationSchema={validationSchema}>
      <PaddedTextField aria-label={I18n.t('publisher.event_types.location.custom_location_label')} autoFocus={isNoTouchDevice()} name="location" />
      {canHideLocation && <>
          <RadioField label={I18n.t('publisher.event_types.location.display_booking')} name="hideLocation" value="visible" />
          <RadioField label={I18n.t('publisher.event_types.location.display_confirmation')} name="hideLocation" value="hidden" />
        </>}
    </CustomLocationPopup>;
};

require("./custom_popup.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./custom_popup.js");